import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import DevTools from "@/components/DevTools";
import { createRootRoute } from "@tanstack/react-router";
import { retainSearchParams } from "@tanstack/react-router";
import z from "zod";

const PortalRoute = () => {
  return (
    <>
      <Outlet />
      <Suspense>
        <DevTools />
      </Suspense>
    </>
  );
};
const buildingSearchSchema = z.object({
  building: z.string().optional().catch(""),
});

export const Route = createRootRoute({
  search: {
    middlewares: [retainSearchParams(["building"])],
  },
  validateSearch: (search) => buildingSearchSchema.parse(search),
  component: () => {
    return <PortalRoute />;
  },
});
